import(/* webpackMode: "eager", webpackExports: ["PrismeProvider"] */ "/builds/PortailVente/mCommerce-SSR/b-you/node_modules/@bytel/logger-nextjs/dist/client.js");
;
import(/* webpackMode: "eager" */ "/builds/PortailVente/mCommerce-SSR/b-you/node_modules/next-runtime-env/build/provider/env-provider.js");
;
import(/* webpackMode: "eager" */ "/builds/PortailVente/mCommerce-SSR/b-you/node_modules/next-runtime-env/build/provider/use-env-context.js");
;
import(/* webpackMode: "eager" */ "/builds/PortailVente/mCommerce-SSR/b-you/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/builds/PortailVente/mCommerce-SSR/b-you/src/app/styles/global.scss");
;
import(/* webpackMode: "eager", webpackExports: ["Header"] */ "/builds/PortailVente/mCommerce-SSR/b-you/src/components/layout/header.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/builds/PortailVente/mCommerce-SSR/b-you/src/components/Loading.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/builds/PortailVente/mCommerce-SSR/b-you/src/components/snack-bar.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SSIBlock"] */ "/builds/PortailVente/mCommerce-SSR/b-you/src/components/ssi-block.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TrilogyProvider"] */ "/builds/PortailVente/mCommerce-SSR/b-you/src/providers/trilogy.tsx");
